import React from "react"
import { Link } from "react-router-dom"
// import ReactWeather from "react-open-weather"
import "react-open-weather/lib/css/ReactWeather.css"

const Header = () => (
  <header id="masthead" className="header-default affix-top sticky-header ">
    <div className="row">
      <div className="header-menu col-sm-12 tm-table">
        <div
          className="menu-mobile-effect navbar-toggle"
          data-effect="mobile-effect"
        >
          <div className="icon-wrap">
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </div>
        </div>
        <div className="width-logo sm-logo table-cell text-center">
          <Link
            to="/"
            className="no-sticky-logo"
            title="Hotel HTML Template"
          >
            <img className="logo" alt="" src="images/logo1.png" />
            <img
              className="mobile-logo"
              src="images/logo1-sticky.png"
              alt=""
            />
          </Link>
          <Link to="/" className="sticky-logo">
            <img src="images/logo1-sticky.png" alt="" />
          </Link>
        </div>
        <div className="width-navigation navigation table-cell">
          <div className="top-toolbar clearfix">
            <div className="toolbar-info pull-left col-sm-4">
              <i className="ion-ios-telephone" />{" "}
              <span className="label">Besoin d'aide? Appelez-nous au:</span>
              <a className="value" href="tel:+22505222222">
                {" "}
                (+225) 05 222 222
              </a>
            </div>
            <div className="toolbar-right pull-right col-sm-8">
              <ul className="top-menu">
                <li className="menu-item">
                  <Link to="/about">Notre Histoire</Link>
                </li>
                <li className="menu-item">
                  <Link to="/events">Evenements</Link>
                </li>
                <li className="menu-item">
                  <Link to="/about">Galerie</Link>
                </li>
              </ul>
            </div>
          </div>
          <ul className="nav main-menu">
            <li className="menu-item">
              <Link to="/">Accueil</Link>
            </li>
            <li className="menu-item">
              <Link to="/about">A propos</Link>
            </li>
            <li className="menu-item">
              <Link to="/rooms">Chambres</Link>
            </li>
            <li className="menu-item">
              <Link to="/events">Evenements</Link>
            </li>
            <li className="menu-item">
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
          <div className="header-right">
            <Link to="/rooms" className="btn-book">
              Réservation
            </Link>
          </div>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
